<template>
  <ViewEntityContainer :entityName="entityName" :identifier="$route.params.contractId" :getMethod="getContractById"
    :refreshOnTimestamp="true" :notificationListeners="[srEventKey]" :notificationValidator="notificationValidator">
  </ViewEntityContainer>
</template>


<script>
import clientAPI from "@/api/ClientAPIMixin.js";
import SRConst from "@/helpers/Constants/SignalRConstants.js";
import ViewEntityContainer from "@/views/pim/suppliers/ViewEntityContainer.vue";
import EntityNames from "@/helpers/Constants/EntityNames.js";

export default {
  name: "ViewContractContainer",
  components: {
    ViewEntityContainer,
  },
  mixins: [clientAPI],

  data() {
    return {
      entityName: EntityNames.Contract
    };
  },

  methods: {
    notificationValidator(args, identifier) {
      return args && args.contractId == identifier;
    },
  },

  computed: {
    srEventKey() {
      return SRConst.EventKeys.ContractChange;
    },
  },

  watch: {},
};
</script>

<style lang="scss" scoped></style>